import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formattedDate, formattedDateTypeTwo, getCurrentDateTime1 } from "../../../../Common/helper/helpar";

export const FrequencyBinsExport = ({ data, fromDate, toDate }) => {
  const currentDateTime = getCurrentDateTime1();
  const headerText = `Frequency Of GVPs Attended Daily Report as on ` + `(${formattedDateTypeTwo(fromDate)} to ${formattedDateTypeTwo(toDate)})`;
  const topHeaderText = `Frequency Of GVPs Attended Daily Report is generated on (${currentDateTime})`;

  /* ================= CALCULATE TOTALS ================= */

  const calculateTotals = () => {
    return data.reduce(
      (acc, row) => {
        acc.totalGVPs += Number(row.totalGVPs || 0);
        acc.attended += Number(row.attended || 0);
        acc.performance += Number(row.performance || 0);
        return acc;
      },
      {
        totalGVPs: 0,
        attended: 0,
        performance: 0,
      }
    );
  };

  const totals = calculateTotals();

  /* ===================== EXCEL DOWNLOAD ===================== */

  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Frequency of Bins Report");
  
    /* ===== Row 1 - Report Generated On (Right Side) ===== */
    worksheet.addRow([topHeaderText]);
    worksheet.mergeCells(1, 1, 1, 7);
  
    worksheet.getCell(1, 1).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
  
    worksheet.getCell(1, 1).font = { bold: true };
  
    /* ===== Row 2 - Title ===== */
    worksheet.addRow([headerText]);
    worksheet.mergeCells(2, 1, 2, 7);
  
    worksheet.getCell(2, 1).font = { bold: true, size: 14 };
    worksheet.getCell(2, 1).alignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
    };
  
    worksheet.addRow([]);
  
    /* ===== Table Header ===== */
    const headerRow = worksheet.addRow([
      "S.No",
      "Date",
      "Shift",
      "Total number of GVP's in the All Circles (a)",
      "Total number of GVP's Attended in the All Circles (b)",
      "Performance",
      "Remarks",
    ]);
  
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = {
        wrapText: true,
        vertical: "middle",
        horizontal: "center",
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });
  
    /* ===== Data ===== */
    data.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        formattedDate(item.date),
        item.shiftName || "-",
        item.totalGVPs || 0,
        item.attended || 0,
        item.performance || 0,
        item.remarks || "N/A",
      ]);
    });
  
    /* ===== Grand Total ===== */
    const totalRow = worksheet.addRow([
      "",
      "",
      "Grand Total",
      totals.totalGVPs,
      totals.attended,
      "",
      "",
    ]);
  
    totalRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
    });
  
    worksheet.columns = [
      { width: 6 },
      { width: 18 },
      { width: 15 },
      { width: 35 },
      { width: 40 },
      { width: 18 },
      { width: 25 },
    ];
  
    const buffer = await workbook.xlsx.writeBuffer();
  
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
  
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement("a");
    a.href = url;
    a.download = "FrequencyOfBinsReport.xlsx";
    a.click();
  
    URL.revokeObjectURL(url);
  };
  

  /* ===================== PDF DOWNLOAD ===================== */

  const downloadAsPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");
    const styledText = (text, x, y, size, options = {}) => {
        const originalSize = doc.getFontSize();
        doc.setFontSize(size);
        doc.text(text, x, y, options);
        doc.setFontSize(originalSize); // Reverts back automatically
    };

    doc.setFontSize(12);

    // doc.text(
    //   reportTitle,
    //   148,
    //   15,
    //   { align: "center", maxWidth: 250 }
    // );

    const tableColumns = [
      "S.No",
      "Date",
      "Shift",
      "Total number of GVP's in the All Circles (a)",
      "Total number of GVP's Attended in the All Circles (b)",
      "Performance",
      "Remarks",
    ];

    const tableRows = data.map((item, index) => [
      index + 1,
      formattedDate(item.date),
      item.shiftName || "-",
      item.totalGVPs || 0,
      item.attended || 0,
      item.performance || 0,
      item.remarks || "N/A",
    ]);

    tableRows.push([
      "",
      "",
      "Grand Total",
      totals.totalGVPs,
      totals.attended,
      "",
      "",
    ]);
    const pageWidth = doc.internal.pageSize.width;
    const titleX = pageWidth / 2;
    styledText(topHeaderText, titleX, 15, 12, { align: "center" });
    styledText(headerText, titleX, 24, 14, { align: "center" });

    autoTable(doc, {
      head: [tableColumns],
      body: tableRows,
      startY: 30,
      styles: { halign: "center", valign: "middle" },
      headStyles: { halign: "center" },
      didParseCell: (data) => {
        if (data.row.raw[1] === "Total") {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });
    

    doc.save("FrequencyOfBinsReport.pdf");
  };

  /* ===================== UI ===================== */

  return (
    <>
      <button className="btn btn-excel me-2" onClick={downloadAsPDF}>
        <i className="fa-solid fa-file-pdf me-1"></i> PDF
      </button>

      <button className="btn btn-excel" onClick={downloadAsExcel}>
        <i className="fa-solid fa-file-excel me-1"></i> Excel
      </button>
    </>
  );
};
